import Excel from "exceljs";
import saveAs from "file-saver";
import {getPtqrCellStyle, getColorFromStyle} from '../helpers/style.helper';

const HR_BLACK_HEADERS_STYLES = {
    style: {
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    },
    fill: {
        type: 'pattern',
        pattern:'solid',
        fgColor: {argb: '00000000'},
        bgColor: {argb: '00000000'}
    },
    font: {
        color: {argb: '00ffffff'},
        family: 2,
        size: 10,
        name: 'Arial',
        bold: true
    },
};

const ARIAL_10 = {
    color: {argb: '00000000'},
    family: 2,
    size: 10,
    name: 'Arial'
}

const ARIAL_10_BOLD_LEFT = {
    alignment: { vertical: 'middle', horizontal: 'left'},
    font: { bold:true, ... ARIAL_10 }
}

const ARIAL_10_BORDER = {
    alignment: { vertical: 'middle', horizontal: 'left'},
    font: { bold:true, ... ARIAL_10 },
    border: {top: {style: 'thin'}}
}

const ARIAL_10_CENTER = {
    alignment: { vertical: 'middle', horizontal: 'center'},
    font: ARIAL_10
}

class ExportServiceClass {
    constructor() {
        this.token = '';
    }

    createBook(username) {
        const wb = new Excel.Workbook();
        wb.creator = 'Riverside KPI App';
        wb.lastModifiedBy = username;
        wb.created = new Date();

        return wb;
    }

    async downloadBook(workbook, filename) {
        await workbook.xlsx.writeBuffer().then(function(buffer) {
            saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                filename + '.xlsx'
            );
        });
    }

    async downloadKpi(sections, username, filename, isMonthly, headers) {
        let pages = [filename];
        const workbook = this.createBook(username);
        if (isMonthly === true) {
            pages = ['Actual vs Budget', 'Actual vs Prior Year','Quarterly'];
        }

        pages.map((title, pageNumber) => {
            const sheet = workbook.addWorksheet(title);
            sheet.views = [{ state: 'frozen', xSplit: 3, ySplit: 1, topLeftCell: 'D2'}];

            if(!isMonthly){
                sheet.getRow(1).getCell(7).value = "Week Ending";
                sheet.getRow(1).getCell(7).style = {
                    font: {color: {argb: '00FFFFFF'}, family: 2, name: 'Arial', bold: true, size: 20 },
                    alignment: {vertical: 'middle', horizontal: 'left'},
                }
            }

            sheet.getRow(1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            };

            sheet.getRow(1).font = {
                color: {argb: '00000000'},
                family: 2,
                name: 'Arial',
                bold: true
            };

            let kpis = [];
            let quarterly = [];
            // Dates columns
            headers.dates.map(id => {
                let data = {
                    header: id.toUpperCase(),
                    key: id,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'center' } },
                    width: 14
                };
                kpis.push(data);
            });
            if(isMonthly){
                headers.quarterly.map(id => {
                    let data = {
                        header: id.toUpperCase(),
                        key: id,
                        style: {
                            alignment: { vertical: 'middle', horizontal: 'center' } },
                        width: 14
                    };
                    quarterly.push(data);
                });
            }

            var headerColumns  = [
                { header: 'TITLE', key: 'title', width: 35,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'left', wrapText: true, indent: 1 },
                        font: { family: 2, name: 'Arial', bold: true },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                            bgColor: {argb: '00f2f2f2'}
                        }
                    }
                },
                { header: 'TAXONOMY & DEF.', key: 'taxonomy', width: 35,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                        font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                            bgColor: {argb: '00d2e6ff'}
                        }
                    }
                },
                { header: 'TYPE', key: 'type', width: 12,
                    style: {
                        alignment: {vertical: 'middle', horizontal: 'center'},
                        font: { family: 2, name: 'Arial', size: 8 },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                            bgColor: {argb: '00f2f2f2'}
                        }
                    }
                },
                ... (pageNumber != 2)? kpis : quarterly,
                { header: 'COMMENTS.', key: 'comments', width: 50, outlineLevel: 1,
                    style: {
                        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                        font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: '00000000'},
                            bgColor: {argb: '00000000'}
                        }
                    }
                }
            ];

            for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
                var column = headerColumns[columnIndex];
                sheet.getRow(2).getCell(columnIndex+1).value = column.header;
                sheet.getRow(2).getCell(columnIndex+1).style = column.style;
                sheet.getRow(2).getCell(columnIndex+1).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '001f53a1'},
                    bgColor: {argb: '001f53a1'}
                };

                sheet.getRow(2).getCell(columnIndex+1).font = {
                    color: {argb: '00FFFFFF'},
                    family: 2,
                    name: 'Arial',
                    bold: true
                };
                sheet.columns[columnIndex].key = column.key;
                sheet.columns[columnIndex].width = column.width;
                sheet.columns[columnIndex].style.alignment = column.style.alignment;
            }

            sheet.font = {
                family: 2,
                name: 'Arial',
                size: 10
            };

            sections.map((section, section_id) => {
                let row = sheet.addRow({title: section.title});
                row.fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '00FFFFFF'},
                    bgColor: {argb: '00FFFFFF'}
                };

                row.font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    bold: true,
                    size: 10
                };

                for(let i = 1; i <= headerColumns.length; i++){
                    row.getCell(i). fill = { type: 'pattern', pattern:'solid', fgColor: {argb: '00404040'}, bgColor: {argb: '00404040'} };
                    row.getCell(i).font = { color: {argb: '00f8f9fa'}, family: 2, name: 'Arial', bold: true };
                }

                if (section.kpis) {
                    section.kpis.map((kpi, kpi_id) => {
                        //Fill cells with data
                        if (kpi.kpiData) {
                            let rowDataActual = {title: kpi.title, taxonomy: kpi.taxonomy, type: 'ACTUAL', comments: kpi.comments};
                            let rowDataBudget = {title: '', taxonomy: '', type: pageNumber  != 1 ? 'BUDGET': 'PRIOR YEAR', comments: kpi.comments};
                            let rowDataPriorYear = {title: '', taxonomy: '', type: 'PRIOR YEAR', comments: kpi.comments}; //Used only when it's monthly quarterly report
                            Object.keys(kpi.kpiData).map(cell => {
                                if(pageNumber != 2 && cell != 'q1' && cell != 'q2' && cell != 'q3' && cell != 'q4' ){
                                    let kpiValue = pageNumber == 0? kpi.kpiData[cell].budget: kpi.kpiData[cell].prior;
                                    if (kpi.format == 2) {
                                        rowDataActual[cell] = parseFloat(kpi.kpiData[cell].actual * 1) / 100;
                                        rowDataBudget[cell] = parseFloat(kpiValue * 1) / 100;
                                    } else {
                                        rowDataActual[cell] = kpi.kpiData[cell].actual * 1;
                                        rowDataBudget[cell] = kpiValue * 1;
                                    }
                                }else if( pageNumber == 2 && (cell == 'q1' || cell == 'q2' || cell == 'q3' || cell == 'q4')){
                                    if (kpi.format == 2) {
                                        rowDataActual[cell] = parseFloat(kpi.kpiData[cell].actual || 0 * 1) / 100;
                                        rowDataBudget[cell] = parseFloat(kpi.kpiData[cell].budget || 0 * 1) / 100;
                                        rowDataPriorYear[cell] = parseFloat(kpi.kpiData[cell].prior || 0 * 1) / 100;
                                    } else {
                                        rowDataActual[cell] = kpi.kpiData[cell].actual || 0 * 1;
                                        rowDataBudget[cell] = kpi.kpiData[cell].budget || 0 * 1;
                                        rowDataPriorYear[cell] = kpi.kpiData[cell].prior || 0 * 1;
                                    }
                                }

                            });

                            let rowActual = sheet.addRow(rowDataActual);
                            let rowBudget = sheet.addRow(rowDataBudget);
                            if(pageNumber == 2){
                                var rowPriorYear = sheet.addRow(rowDataPriorYear);
                                rowPriorYear.getCell(3).style = { alignment: {vertical: 'middle', horizontal: 'center'}, font: { family: 2, name: 'Arial', size: 8, italic: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };
                            }
                            //Manually apply colors to fixed columns due it's taking columns color.
                            //Title
                            rowActual.getCell(1).style = { alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true }, font: { family: 2, name: 'Arial', size: 10, bold: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };
                            //Taxonomy
                            rowActual.getCell(2).style = { alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true }, font: { family: 2, name: 'Arial', size: 10, color: { argb: '000b52ff' } }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'}, bgColor: {argb: '00d2e6ff' } } };
                            //Type
                            rowActual.getCell(3).style = { alignment: { vertical: 'middle', horizontal: 'center'}, font: { family: 2, name: 'Arial', size: 8, italic: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };
                            rowBudget.getCell(3).style = { alignment: { vertical: 'middle', horizontal: 'center'}, font: { family: 2, name: 'Arial', size: 8, italic: true }, fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } } };

                            //Merge title and taxonomy columns (vertically each one)
                            if(pageNumber != 2){
                                sheet.mergeCells(rowActual.getCell(1).address+':'+rowBudget.getCell(1).address);
                                sheet.mergeCells(rowActual.getCell(2).address+':'+rowBudget.getCell(2).address);
                            }else{
                                sheet.mergeCells(rowActual.getCell(1).address+':'+rowPriorYear.getCell(1).address);
                                sheet.mergeCells(rowActual.getCell(2).address+':'+rowPriorYear.getCell(2).address);
                            }

                            var index = 4;
                            Object.keys(kpi.kpiData).forEach(element => {
                                //Add style to cells
                                let style = kpi.kpiData[element].style;
                                let budgetStyle = pageNumber != 1 && kpi.kpiData[element].budgetStyle ? kpi.kpiData[element].budgetStyle : { text: "000000", background: "FFFFFF" };
                                if( (pageNumber == 0 && element != 'q1' && element != 'q2' && element != 'q3' && element != 'q4' )){
                                    rowActual.getCell(index).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00" + style.text}
                                    };

                                    rowActual.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00"+style.background},
                                        bgColor: {argb: "00"+style.background}
                                    }

                                    rowBudget.getCell(index).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00" + budgetStyle.text}
                                    };

                                    rowBudget.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        size: 10,
                                        fgColor: {argb: "00" + budgetStyle.background},
                                        bgColor: {argb: "00" + budgetStyle.background}
                                    }
                                }else if( pageNumber == 2 && (element == 'q1' || element == 'q2' || element == 'q3' || element == 'q4')){
                                    let columnsBefore = 12; //months
                                    rowActual.getCell(index-columnsBefore).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00" + style.text}
                                    };

                                    rowActual.getCell(index-columnsBefore).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00"+style.background},
                                        bgColor: {argb: "00"+style.background}
                                    }

                                    rowBudget.getCell(index-columnsBefore).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00" + budgetStyle.text}
                                    };

                                    rowBudget.getCell(index-columnsBefore).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00" + budgetStyle.background},
                                        bgColor: {argb: "00" + budgetStyle.background}
                                    }

                                    rowPriorYear.getCell(index-columnsBefore).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00000000"}
                                    };

                                    rowPriorYear.getCell(index-columnsBefore).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00FFFFFF"},
                                        bgColor: {argb: "00FFFFFF"}
                                    }
                                }else if (pageNumber == 1){
                                    rowActual.getCell(index).font = {
                                        family: 2,
                                        name: 'Arial',
                                        color: {argb: "00000000"},
                                        size: 10
                                    };
                                    rowActual.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        fgColor: {argb: "00FFFFFF"},
                                        bgColor: {argb: "00FFFFFF"}
                                    }
                                    rowBudget.getCell(index).font = {
                                        family: 2,
                                        name: 'Arial',
                                        size: 10,
                                        color: {argb: "00000000"}
                                    };
                                    rowBudget.getCell(index).fill = {
                                        type: 'pattern',
                                        pattern:'solid',
                                        size: 10,
                                        fgColor: {argb: "00FFFFFF"},
                                        bgColor: {argb: "00FFFFFF"}
                                    }
                                }

                                index++;
                            });

                            if(pageNumber == 2){
                                rowPriorYear.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            }else{
                                rowBudget.border = {
                                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                                };
                            }

                            switch(kpi.format) {
                                case 1:
                                    rowActual.numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                    rowBudget.numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                    break;
                                case 2:
                                    rowActual.numFmt = '#,##0.0%';
                                    rowBudget.numFmt = '#,##0.0%';
                                    break;
                                case 0:
                                case 3:
                                    rowActual.numFmt = '#,##0.0';
                                    rowBudget.numFmt = '#,##0.0';
                                    break;
                                case 4:
                                    rowActual.numFmt = '#,##0.0x';
                                    rowBudget.numFmt = '#,##0.0x';
                                    break;
                                case 5:
                                    rowActual.numFmt = '#,##0.0" bps"';
                                    rowBudget.numFmt = '#,##0.0" bps"';
                                    break;
                                default:
                                    break;
                            }
                        }
                    });
                }
            });
        });

        await this.downloadBook(workbook, filename);
    }

    async downloadSDR(sections, username, filename, headers) {
        const workbook = this.createBook(username);
        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 2, ySplit: 1, topLeftCell: 'C2'}];

        sheet.getRow(0).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor: {argb: '00FFFFFF'},
            bgColor: {argb: '00FFFFFF'}
        };

        sheet.getRow(0).font = {
            color: {argb: '00000000'},
            family: 2,
            name: 'Arial',
            bold: true
        };

        let kpis = [];
        // Dates columns
        headers.map(id => {
            let data = {
                header: id.toUpperCase(),
                key: id,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center' } },
                width: 14
            };
            kpis.push(data);
        });

        var headerColumns  = [
            { header: 'TITLE', key: 'title', width: 40,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true, indent: 1 },
                    font: { family: 2, name: 'Arial', bold: true },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'TAXONOMY & DEF.', key: 'taxonomy', width: 40,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            ... kpis,
            { header: 'COMMENTS.', key: 'comments', width: 50, outlineLevel: 1,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00000000'},
                        bgColor: {argb: '00000000'}
                    }
                }
            }

        ];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            sheet.getRow(2).getCell(columnIndex+1).value = column.header;
            sheet.getRow(2).getCell(columnIndex+1).style = column.style;
            sheet.getRow(2).getCell(columnIndex+1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '001f53a1'},
                bgColor: {argb: '001f53a1'}
            };

            sheet.getRow(2).getCell(columnIndex+1).font = {
                color: {argb: '00FFFFFF'},
                family: 2,
                name: 'Arial',
                bold: true
            };
            sheet.columns[columnIndex].key = column.key;
            sheet.columns[columnIndex].width = column.width;
            sheet.columns[columnIndex].style.alignment = column.style.alignment;
        }

        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        sections.map((section, section_id) => {
            let row = sheet.addRow({title: section.title});
            row.fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            };

            row.font = {
                color: {argb: '00000000'},
                family: 2,
                name: 'Arial',
                bold: true,
                size: 10
            };

            for(let i = 1; i <= headerColumns.length; i++){
                row.getCell(i). fill = { type: 'pattern', pattern:'solid', fgColor: {argb: '00404040'}, bgColor: {argb: '00404040'} };
                row.getCell(i).font = { color: {argb: '00f8f9fa'}, family: 2, name: 'Arial', bold: true };
            }

            if (section.kpis) {
                section.kpis.map((kpi) => {
                    // Fill cells with data
                    if (kpi.kpiData) {
                        let rowDataActual = {title: kpi.title, taxonomy: kpi.taxonomy, comments: kpi.comments};
                        Object.keys(kpi.kpiData).map(cell => {
                            if (kpi.format == 2) {
                                rowDataActual[cell] = parseFloat(kpi.kpiData[cell].actual * 1) / 100;
                            } else {
                                rowDataActual[cell] = kpi.kpiData[cell].actual * 1;
                            }
                        });
                        let rowActual = sheet.addRow(rowDataActual);
                        // Manually apply colors to fixed columns due it's taking columns color.
                        // Title
                        rowActual.getCell(1).style = {
                            alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true },
                            font: { family: 2, name: 'Arial', size: 10, bold: true },
                            fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'}, bgColor: {argb: '00f2f2f2' } }
                        };
                        // Taxonomy
                        rowActual.getCell(2).style = {
                            alignment: { indent: 2, vertical: 'middle', horizontal: 'left', wrapText: true },
                            font: { family: 2, name: 'Arial', size: 10, color: { argb: '000b52ff' } },
                            fill :  { type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'}, bgColor: {argb: '00d2e6ff' } }
                        };

                        var index = 3;
                        Object.keys(kpi.kpiData).forEach(element => {
                            // Add style to cells
                            let style = (kpi.kpiData[element].style) ? kpi.kpiData[element].style : {text: null, background: null};
                            rowActual.getCell(index).font = {
                                family: 2,
                                name: 'Arial',
                                size: 10,
                                color: {argb: "00" + (style.text || '000000')}
                            };

                            rowActual.getCell(index).fill = {
                                type: 'pattern',
                                pattern:'solid',
                                fgColor: {argb: "00" + (style.background || 'FFFFFF')},
                                bgColor: {argb: "00" + (style.background || 'FFFFFF')}
                            }
                            index++;
                        });
                        rowActual.height = 40;
                        switch(kpi.format) {
                            case 1:
                                rowActual.numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                break;
                            case 2:
                                rowActual.numFmt = '#,##0.0%';
                                break;
                            case 0:
                            case 3:
                                rowActual.numFmt = '#,##0.0';
                                break;
                            case 4:
                                rowActual.numFmt = '#,##0.0x';
                                break;
                            case 5:
                                rowActual.numFmt = '#,##0.0" bps"';
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        });

        await this.downloadBook(workbook, filename);
    }

    async downloadTeams(teams, username, filename, rollingMonths) {
        const workbook = this.createBook(username);

        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 3, ySplit: 3, topLeftCell: 'D4'}];

        // Merges
        const titleCellsToMerge = [
            sheet.getRow(2).getCell(12).address + ':' + sheet.getRow(2).getCell(24).address,
            sheet.getRow(2).getCell(26).address + ':' + sheet.getRow(2).getCell(29).address,
            sheet.getRow(2).getCell(31).address + ':' + sheet.getRow(2).getCell(43).address,
            sheet.getRow(2).getCell(45).address + ':' + sheet.getRow(2).getCell(57).address,
            sheet.getRow(2).getCell(59).address + ':' + sheet.getRow(2).getCell(71 + rollingMonths).address,
            sheet.getRow(2).getCell(73 + rollingMonths).address + ':' + sheet.getRow(2).getCell(85 + rollingMonths).address
        ];

        titleCellsToMerge.forEach(range => sheet.mergeCells(range));

        const titles = [
            { "title": "SALES PERFORMANCE REPORT", "row": 1, "column": 1 },
            { "title": "YEAR", "row": 2, "column": 1 },
            { "title": filename.split("-")[1], "row": 1, "column": 2 },
            { "title": filename.split("-")[2], "row": 2, "column": 2 },
            { "title": "EMPLOYEE ATTAINMENT", "row": 2, "column": 12 },
            { "title": "QUARTERLY ATTAINMENT", "row": 2, "column": 26 },
            { 'title': 'PIPELINE TO QUOTA RATIO', 'row': 2, 'column': 31 },
            { "title": "EMPLOYEE PERFORMANCE", "row": 2, "column": 45},
            { "title": `EMPLOYEE QUOTA (ROLLING ${rollingMonths} MONTHS)`, "row": 2, "column": 59},
            { 'title': 'ROLLING GROSS PIPELINE', 'row': 2, 'column': 73 + rollingMonths }
        ];

        titles.forEach(title => {
            var horizontal = (title.column === 1 || title.column === 2)? 'left' : 'center';
            sheet.getRow(title.row).getCell(title.column).value = title.title;
            sheet.getRow(title.row).getCell(title.column).style = {
                font: {color: {argb: '00000000'}, family: 2, name: 'Arial', bold: true, size: 10 },
                alignment: {vertical: 'middle', horizontal: horizontal},
            }
        });

        let employeeCols = [];
        var generalWidth = 18;

        if (!teams[0] || !teams[0].employees[0] || !teams[0].employees[0].employeeData) {
            alert('Not enough data to export.');
            return;
        }

        Object.keys(teams[0].employees[0].employeeData).map(report => {
            Object.keys(teams[0].employees[0].employeeData[report]).map( id => {
                generalWidth = (id == 'Last_12_mo') ? 17 : (id == 'rank') ? 8 : 14;

                employeeCols.push({
                    header: id.replace(/_/g," ").toUpperCase(),
                    key: report + '-' + id,
                    style: {
                        alignment: { vertical: 'middle', wrapText: true, horizontal: 'center' } },
                    width: generalWidth
                });
            });
            employeeCols.push({
                header: '',
                key: report + '-space',
                style: {
                    alignment: {vertical: 'middle', horizontal: 'center'},
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00FFFFFF'},
                        bgColor: {argb: '00FFFFFF'}
                    }
                },
                width: 1
            });
        });

        var headerColumns = [
            { header: 'NAME', key: 'name', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'POSITION', key: 'position', width: 40,
                style: {
                    alignment: { vertical: 'middle',  horizontal: 'center' },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' }, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nSTARTED', key: 'date_started', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial',  size: 10, color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nENDED', key: 'date_ended', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'TENURE\n(MONTHS)', key: 'tenure', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD MONTH', key: 'onboard_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD PERF', key: 'onboard_perf', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'RAMPED MONTH', key: 'ramped_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            ...employeeCols
        ];

        var columnsKey = [];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            columnsKey.push({"key":column.key, "width": column.width});
            sheet.getRow(3).getCell(columnIndex+1).value = column.header;
            sheet.getRow(3).getCell(columnIndex+1).style = column.style;
            sheet.getRow(3).getCell(columnIndex+1).width = column.width;
            sheet.getRow(3).getCell(columnIndex+1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '001f53a1'},
                bgColor: {argb: '001f53a1'}
            };

            sheet.getRow(3).getCell(columnIndex+1).font = {
                color: {argb: '00f8f9fa'},
                family: 2,
                name: 'Arial',
                bold: true
            };
        }

        sheet.columns = columnsKey;
        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        //Set spaces white
        const spaceColumns = titles.slice(4).map(title => (title.column - 1));

        spaceColumns.forEach(columnIndex => {
            sheet.getRow(3).getCell(columnIndex).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            }
        });

        sheet.getRow(3).height = 30;

        teams.map((team) => {
            let row = sheet.addRow({name: team.title});

            row.font = {
                color: {argb: '00f8f9fa'},
                family: 2,
                name: 'Arial',
                size: 10,
                bold: true
            };

            const lastTeamColumn = spaceColumns[spaceColumns.length - 1] + 14;
            for (let teamTitleColumn = 1; teamTitleColumn <= lastTeamColumn; teamTitleColumn++) {
                const fillParams = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb: '00000000'},
                    bgColor: {argb: '00000000'},
                };

                if (spaceColumns.includes(teamTitleColumn)) {
                    fillParams.fgColor.argb = '00FFFFFF';
                    fillParams.bgColor.argb = '00FFFFFF';
                }

                row.getCell(teamTitleColumn).fill = fillParams;
            }

            if (team.employees) {
                team.employees.map((employee) => {
                    if (employee.employeeData) {
                        let rowData = {
                            "name": employee.name,
                            "position": employee.position,
                            "date_started": employee.start_date_formatted,
                            "date_ended": employee.end_date_formatted,
                            "tenure": employee.tenure,
                            "onboard_month": employee.onboard_month,
                            "onboard_perf": employee.onboard_perf,
                            "ramped_month": employee.ramped_month
                        };

                        Object.keys(employee.employeeData).map(report => {
                            // 3 jsons: attainment, performance and quota
                            Object.keys(employee.employeeData[report]).map( id => {
                                if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                                    if(id != 'rank'){
                                        rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                                    }else{
                                        rowData[report+'-'+id] = employee.employeeData[report][id];
                                    }
                                }else if (['performance', 'quota', 'pipeline'].includes(report)){
                                    // Performance, quota and pipeline
                                    if (team.format == 2) {
                                        rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                                    }else{
                                        rowData[report+'-'+id] = employee.employeeData[report][id].value;
                                    }
                                }else{
                                    rowData[report+'-'+id] = employee.employeeData[report][id].value;
                                }
                            });
                            rowData[report+'-space'] = '';
                        });

                        row = sheet.addRow(rowData);
                        for (let columnIndex = 1; columnIndex <= 9; columnIndex++) {
                            var bgColor, horizontalAlignment, bold, fontColor;
                            if(columnIndex == 1){
                                bgColor = '00f2f2f2', horizontalAlignment = 'left', bold = true, fontColor = '00000000';
                            }else{
                                bgColor = '00d2e6ff', horizontalAlignment = 'center', bold = false, fontColor = '000000ff';
                            }
                            row.getCell(columnIndex).style = {
                                alignment: { vertical: 'middle', horizontal: horizontalAlignment },
                                font: { family: 2, bold: bold, name: 'Arial', size: 10 , color : { argb: fontColor } },
                                fill: {
                                    type: 'pattern', pattern: 'solid', fgColor: {argb: bgColor},
                                    bgColor: {argb: bgColor}
                                }
                            }
                        }

                        var index = 9;
                        Object.keys(employee.employeeData).map(report => {
                            //3 jsons: attainment, performance and quota
                            Object.keys(employee.employeeData[report]).map( id => {
                                row.getCell(index).alignment = {
                                    vertical: 'middle',
                                    horizontal: 'center'
                                }

                                row.getCell(index).font = {
                                    family: 2,
                                    size: 10,
                                    name: 'Arial'
                                };
                                if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                                    if(id != 'rank'){
                                        row.getCell(index).font = {
                                            color: {argb: '00'+employee.employeeData[report][id].style.text },
                                            family: 2,
                                            size: 10,
                                            name: 'Arial'
                                        };
                                        row.getCell(index).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            fgColor: {argb: '00'+employee.employeeData[report][id].style.background },
                                            bgColor: {argb: '00'+employee.employeeData[report][id].style.background }
                                        }
                                        row.getCell(index).numFmt = '0.0%';
                                    }
                                }else{
                                    //Performance and quota
                                    if(['ptqr', 'quota'].includes(report)){
                                        row.getCell(index).font = {
                                            color: {argb: '00'+employee.employeeData[report][id].style.text},
                                            family: 2,
                                            size: 10,
                                            name: 'Arial'
                                        };

                                        const ptqrCellStyle = getPtqrCellStyle(employee.employeeData[report][id].value,team.style);

                                        const backgroundColor = report === 'ptqr' ?
                                            getColorFromStyle(ptqrCellStyle) :
                                            '00'+employee.employeeData[report][id].style.background;

                                        row.getCell(index).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            fgColor: {
                                                argb: backgroundColor
                                            },
                                            bgColor: {
                                                argb: backgroundColor
                                            }
                                        }
                                    }
                                    //Set quota and performance format
                                    const formatType = report === 'ptqr' ? 4 : team.format;
                                    switch(formatType) {
                                        case 1:
                                            row.getCell(index).numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                            break;
                                        case 2:
                                            row.getCell(index).numFmt = '#,##0.0%';
                                            break;
                                        case 3:
                                            row.getCell(index).numFmt = '#,##0.0';
                                            break;
                                        case 4:
                                            row.getCell(index).numFmt = '#,##0.0x';
                                            break;
                                        case 5:
                                            row.getCell(index).numFmt = '#,##0.0" bps"';
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                index++;
                            });
                            //Space between tables
                            index++;
                        });

                        row.border = {
                            bottom: {style: 'thin', color: {argb: '00cccccc'}}
                        };

                    }
                });
            }
            let emptyRow = sheet.addRow({name: "", position: "", date_started: "", date_ended: "", tenure: "", });
            emptyRow.fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            };
            emptyRow.commit();
        });

        await this.downloadBook(workbook, filename);
    }

    async downloadIndividualAllPortcos(employees, username, filename, rollingMonths) {
        const workbook = this.createBook(username);

        const sheet = workbook.addWorksheet(filename);
        sheet.views = [{ state: 'frozen', xSplit: 3, ySplit: 3, topLeftCell: 'D4'}];

        // Merges
        const titleCellsToMerge = [
            sheet.getRow(2).getCell(14).address + ':' + sheet.getRow(2).getCell(25).address,
            sheet.getRow(2).getCell(28).address + ':' + sheet.getRow(2).getCell(31).address,
            sheet.getRow(2).getCell(33).address + ':' + sheet.getRow(2).getCell(45).address,
            sheet.getRow(2).getCell(47).address + ':' + sheet.getRow(2).getCell(59).address,
            sheet.getRow(2).getCell(61).address + ':' + sheet.getRow(2).getCell(73 + rollingMonths).address,
            sheet.getRow(2).getCell(75 + rollingMonths).address + ':' + sheet.getRow(2).getCell(87 + rollingMonths).address
        ];

        titleCellsToMerge.forEach(range => sheet.mergeCells(range));

        const titles = [
            { "title": "SALES PERFORMANCE REPORT", "row": 1, "column": 1 },
            { "title": "YEAR", "row": 2, "column": 1 },
            { "title": filename.split("-")[1], "row": 1, "column": 2 },
            { "title": filename.split("-")[2], "row": 2, "column": 2 },
            { "title": "EMPLOYEE ATTAINMENT", "row": 2, "column": 14 },
            { "title": "QUARTERLY ATTAINMENT", "row": 2, "column": 28 },
            { 'title': 'PIPELINE TO QUOTA RATIO', 'row': 2, 'column': 33 },
            { "title": "EMPLOYEE PERFORMANCE", "row": 2, "column": 47},
            { "title": `EMPLOYEE QUOTA (ROLLING ${rollingMonths} MONTHS)`, "row": 2, "column": 61},
            { 'title': 'ROLLING GROSS PIPELINE', 'row': 2, 'column': 75 + rollingMonths }
        ];

        titles.forEach(title => {
            var horizontal = (title.column === 1 || title.column === 2)? 'left' : 'center';
            sheet.getRow(title.row).getCell(title.column).value = title.title;
            sheet.getRow(title.row).getCell(title.column).style = {
                font: {color: {argb: '00000000'}, family: 2, name: 'Arial', bold: true, size: 10 },
                alignment: {vertical: 'middle', horizontal: horizontal},
            }
        });

        let employeeCols = [];
        var generalWidth = 18;

        Object.keys(employees[0].employeeData).map(report => {
            Object.keys(employees[0].employeeData[report]).map( id => {
                generalWidth = (id == 'Last_12_mo') ? 17 : 14;

                employeeCols.push({
                    header: id.replace(/_/g," ").toUpperCase(),
                    key: report + '-' + id,
                    style: {
                        alignment: { vertical: 'middle', wrapText: true, horizontal: 'center' } },
                    width: generalWidth
                });
            });
            employeeCols.push({
                header: '',
                key: report + '-space',
                style: {
                    alignment: {vertical: 'middle', horizontal: 'center'},
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00FFFFFF'},
                        bgColor: {argb: '00FFFFFF'}
                    }
                },
                width: 1
            });
        });

        var headerColumns = [
            { header: 'COMPANY', key: 'company', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'SECTION', key: 'section', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'NAME', key: 'name', width: 33,
                style: {
                    alignment: { vertical: 'middle', horizontal: 'left' },
                    font: { family: 2, name: 'Arial', bold: true, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00f2f2f2'},
                        bgColor: {argb: '00f2f2f2'}
                    }
                }
            },
            { header: 'POSITION', key: 'position', width: 40,
                style: {
                    alignment: { vertical: 'middle',  horizontal: 'center' },
                    font: { family: 2, name: 'Arial', color: { argb: '000000ff' }, size: 10 },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nSTARTED', key: 'date_started', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial',  size: 10, color: { argb: '000000ff' } },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'DATE\nENDED', key: 'date_ended', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'TENURE\n(MONTHS)', key: 'tenure', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD MONTH', key: 'onboard_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'ONBOARD PERF', key: 'onboard_perf', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            { header: 'RAMPED MONTH', key: 'ramped_month', width: 12,
                style: {
                    alignment: {vertical: 'middle',  wrapText: true, horizontal: 'center'},
                    font: { family: 2, name: 'Arial', size: 10, color: { argb: '000000ff'}  },
                    fill: {
                        type: 'pattern', pattern: 'solid', fgColor: {argb: '00d2e6ff'},
                        bgColor: {argb: '00d2e6ff'}
                    }
                }
            },
            ...employeeCols
        ];

        var columnsKey = [];

        for (let columnIndex = 0; columnIndex < headerColumns.length; columnIndex++) {
            var column = headerColumns[columnIndex];
            columnsKey.push({"key":column.key, "width": column.width});
            sheet.getRow(3).getCell(columnIndex+1).value = column.header;
            sheet.getRow(3).getCell(columnIndex+1).style = column.style;
            sheet.getRow(3).getCell(columnIndex+1).width = column.width;
            sheet.getRow(3).getCell(columnIndex+1).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '001f53a1'},
                bgColor: {argb: '001f53a1'}
            };

            sheet.getRow(3).getCell(columnIndex+1).font = {
                color: {argb: '00f8f9fa'},
                family: 2,
                name: 'Arial',
                bold: true
            };
        }

        sheet.columns = columnsKey;
        sheet.font = {
            family: 2,
            name: 'Arial',
            size: 10
        };

        //Set spaces white
        const spaceColumns = titles.slice(4).map(title => (title.column - 1));

        spaceColumns.forEach(columnIndex => {
            sheet.getRow(3).getCell(columnIndex).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00FFFFFF'},
                bgColor: {argb: '00FFFFFF'}
            }
        });

        sheet.getRow(3).height = 30;

        employees.map((employee) => {
            if (employee.employeeData) {
                let rowData = {
                    "company": employee.company,
                    "section": employee.section,
                    "name": employee.name,
                    "position": employee.position,
                    "date_started": employee.start_date_formatted,
                    "date_ended": employee.end_date_formatted,
                    "tenure": employee.tenure,
                    "onboard_month": employee.onboard_month,
                    "onboard_perf": employee.onboard_perf,
                    "ramped_month": employee.ramped_month
                };

                Object.keys(employee.employeeData).map(report => {
                    // Tables
                    Object.keys(employee.employeeData[report]).map( id => {
                        if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                            if(id != 'rank'){
                                rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                            }else{
                                rowData[report+'-'+id] = employee.employeeData[report][id];
                            }
                        }else if (['performance', 'quota', 'pipeline'].includes(report)){
                            if (employee.section_format == 2) {
                                rowData[report+'-'+id] = employee.employeeData[report][id].value / 100;
                            }else{
                                rowData[report+'-'+id] = employee.employeeData[report][id].value;
                            }
                        }else{
                            rowData[report+'-'+id] = employee.employeeData[report][id].value;
                        }
                    });
                    rowData[report+'-space'] = '';
                });

                let row = sheet.addRow(rowData);
                for (let columnIndex = 1; columnIndex <= 11; columnIndex++) {
                    var bgColor, horizontalAlignment, bold, fontColor;
                    if(columnIndex == 1){
                        bgColor = '00f2f2f2', horizontalAlignment = 'left', bold = true, fontColor = '00000000';
                    }else{
                        bgColor = '00d2e6ff', horizontalAlignment = 'center', bold = false, fontColor = '000000ff';
                    }
                    row.getCell(columnIndex).style = {
                        alignment: { vertical: 'middle', horizontal: horizontalAlignment },
                        font: { family: 2, bold: bold, name: 'Arial', size: 10 , color : { argb: fontColor } },
                        fill: {
                            type: 'pattern', pattern: 'solid', fgColor: {argb: bgColor},
                            bgColor: {argb: bgColor}
                        }
                    }
                }

                var index = 11;
                Object.keys(employee.employeeData).map(report => {
                    //3 jsons: attainment, performance and quota
                    Object.keys(employee.employeeData[report]).map( id => {
                        row.getCell(index).alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }

                        row.getCell(index).font = {
                            family: 2,
                            size: 10,
                            name: 'Arial'
                        };
                        if(report == 'attainment' || report == 'attainment_list' || report == 'quarterly_attainment'){
                            if(id != 'rank'){
                                row.getCell(index).font = {
                                    color: {argb: '00'+employee.employeeData[report][id].style.text },
                                    family: 2,
                                    size: 10,
                                    name: 'Arial'
                                };
                                row.getCell(index).fill = {
                                    type: 'pattern',
                                    pattern:'solid',
                                    fgColor: {argb: '00'+employee.employeeData[report][id].style.background },
                                    bgColor: {argb: '00'+employee.employeeData[report][id].style.background }
                                }
                                row.getCell(index).numFmt = '0.0%';
                            }
                        }else{
                            //Performance and quota
                            if(['ptqr', 'quota'].includes(report)){
                                row.getCell(index).font = {
                                    color: {argb: '00'+employee.employeeData[report][id].style.text},
                                    family: 2,
                                    size: 10,
                                    name: 'Arial'
                                };

                                const ptqrCellStyle = getPtqrCellStyle(employee.employeeData[report][id].value,employee.section_style);

                                const backgroundColor = report === 'ptqr' ?
                                    getColorFromStyle(ptqrCellStyle) :
                                    '00'+employee.employeeData[report][id].style.background;

                                row.getCell(index).fill = {
                                    type: 'pattern',
                                    pattern:'solid',
                                    fgColor: {
                                        argb: backgroundColor
                                    },
                                    bgColor: {
                                        argb: backgroundColor
                                    }
                                }
                            }
                            //Set quota and performance format
                            const formatType = report === 'ptqr' ? 4 : employee.section_format;
                            switch(formatType) {
                                case 1:
                                    row.getCell(index).numFmt = '"$"#,##0;[Red]\-"$"#,##0';
                                    break;
                                case 2:
                                    row.getCell(index).numFmt = '#,##0.0%';
                                    break;
                                case 3:
                                    row.getCell(index).numFmt = '#,##0.0';
                                    break;
                                case 4:
                                    row.getCell(index).numFmt = '#,##0.0x';
                                    break;
                                case 5:
                                    row.getCell(index).numFmt = '#,##0.0" bps"';
                                    break;
                                default:
                                    break;
                            }
                        }
                        index++;
                    });
                    //Space between tables
                    index++;
                });

                row.border = {
                    bottom: {style: 'thin', color: {argb: '00cccccc'}}
                };
            }
        });
        
        let emptyRow = sheet.addRow({name: "", position: "", date_started: "", date_ended: "", tenure: "", });
        emptyRow.fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor: {argb: '00FFFFFF'},
            bgColor: {argb: '00FFFFFF'}
        };
        emptyRow.commit();

        await this.downloadBook(workbook, filename);
    }

    async downloadCommonHrReport(headers, items, filename, hrTabName, cellCountToFreeze) {
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        const tableTitleCell = sheet.addRow([`${hrTabName.toUpperCase()} REPORT`]);

        tableTitleCell.font = {
            family: 2,
            name: 'Arial',
            size: 12,
            bold: true,
        };

        const headerRow = sheet.addRow(headers.map(h => h.title.toUpperCase()));
        headerRow.height = 30;

        headers.forEach((header, index) => {
            const headerCell = headerRow.getCell(index+1);
            headerCell.style = {
                alignment: { vertical: 'middle', horizontal: 'center' },
            };
            headerCell.style = HR_BLACK_HEADERS_STYLES.style;
            headerCell.fill = HR_BLACK_HEADERS_STYLES.fill;
            headerCell.font = HR_BLACK_HEADERS_STYLES.font;
        });

        for (const item of items) {
            const row = [];

            for (const header of headers) {
                row.push(item[header.key]);
            }
            const sheetRow = sheet.addRow(row);

            for (let i = 1; i <= headers.length; i++) {
                const cell = sheetRow.getCell(i);
                if(i <= 6){
                    cell.style = {alignment: { wrapText: true }};
                }

                cell.font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    size: 10,
                    bold: false
                };
            }
        }

        sheet.columns = headers.map(h => ({width: h.exportWidth}));
        sheet.views = [
                {
                    state: 'frozen',
                    xSplit: cellCountToFreeze,
                    ySplit: 2,
                }
            ];

        await this.downloadBook(workbook, filename);
    }

    async downloadStaffingBudget(reportData, yearlyHeadCount, filename, year, isFacilitator) {
        const { staff: monthlyKeys } = reportData.headers;
        const { staff: staffItems } = reportData;

        const staffHeaders = [
            {
                name: 'EMPLOYEE NAME',
                key: 'employee_name',
                exportWidth: 20,
            },
            {
                name: 'JOB ROLE',
                key: 'job_role',
                exportWidth: 30,
            },
            {
                name: 'DEPARTMENT',
                key: 'department',
                exportWidth: 15,
            },
            ...monthlyKeys.map(key => ({name: key, key, exportWidth: 15, isMonth: true}))
        ];

        if (!isFacilitator) {
            staffHeaders.unshift({
                name: 'COMPANY',
                key: 'company',
                exportWidth: 40,
            });
        }

        const yearlyHeadCountMonth = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const yearlyHeadCountHeaders = ['BUDGET', '', '', '', ...yearlyHeadCountMonth.map((header) => `${header.toUpperCase()}/${year}`)];

        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        sheet
            .addRow(['STAFFING BUDGET REPORT'])
            .font = {
                family: 2,
                name: 'Arial',
                size: 12,
                bold: true,
            };

        if (isFacilitator) {
            const yearlyHeadersRow = sheet.addRow(yearlyHeadCountHeaders);

            for (let i = 1; i <= yearlyHeadCountHeaders.length; i++) {
                const headerCell = yearlyHeadersRow.getCell(i);

                headerCell.style = HR_BLACK_HEADERS_STYLES.style;
                headerCell.fill = HR_BLACK_HEADERS_STYLES.fill;
                headerCell.font = HR_BLACK_HEADERS_STYLES.font;
            }

            Object.keys(yearlyHeadCount).forEach(key => {
                const row = sheet.addRow([key, '', '', '', ...yearlyHeadCount[key]]);

                row.getCell(4).font = {bold: true};

                row.eachCell(c => c.style = {alignment: { horizontal: 'center' }});
            });

            // merge first table budget cells
            for (let i = 1; i < 5; i++) {
                sheet.mergeCells(i, 1, i, 4);

                if (i > 2) {
                    sheet.getRow(i).getCell(1).style = {alignment: { horizontal: 'center' }};
                }
            }

            sheet.addRow([]);
        }

        const staffHeadersRow = sheet.addRow(staffHeaders.map(header => header.name));

        for (let i = 1; i <= staffHeaders.length; i++) {
            const headerCell = staffHeadersRow.getCell(i);

            headerCell.style = HR_BLACK_HEADERS_STYLES.style;
            headerCell.fill = HR_BLACK_HEADERS_STYLES.fill;
            headerCell.font = HR_BLACK_HEADERS_STYLES.font;
        }

        for (const staff of staffItems) {
            const row = [];

            staffHeaders.forEach((header, index) => {
                const value = !staff[header.key] && index > 3 ? '0' : staff[header.key];

                row.push(value);
            });

            const staffRow = sheet.addRow(row);

            staffRow.eachCell((c, index) => {
                if (index > 4) {
                    c.style = {alignment: { horizontal: 'center' }};
                }else{
                    c.style = {alignment: { wrapText: true }};
                }
            });

            for (let i = 1; i <= staffHeaders.length; i++) {
                staffRow.getCell(i).font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    size: 10,
                    bold: false
                };
            }
        }

        sheet.columns = staffHeaders.map((h) => ({width: h.exportWidth}));

        sheet.views = [
            {
                state: 'frozen',
                xSplit: 4,
                ySplit: 2,
            }
        ];

        await this.downloadBook(workbook, filename);
    }

    async downloadCandidates(candidates, headers, filename, isFacilitator) {
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);
        sheet
            .addRow(['CANDIDATES REPORT'])
            .font = {
                family: 2,
                name: 'Arial',
                size: 12,
                bold: true,
        };

        const rowHeaders = [];
        for (let i = 0; i < headers.length; i++) {
            rowHeaders.push(headers[i].title.toUpperCase());

            if (headers[i].isStageHeader) {
                rowHeaders.push('#');
            }
        }

        const stageHeadersCells = [];
        rowHeaders.forEach((header, i) => {
            if (header === '#') {
                stageHeadersCells.push({leftIndex: i - 1, rightIndex: i});
                rowHeaders[i] = '';
            }
        });

        stageHeadersCells.pop();

        const reducedStageIndexes = stageHeadersCells.reduce((acc, cur) => [...acc, cur.leftIndex, cur.rightIndex], []);
        const nonStageHeadersCells = [];
        rowHeaders.forEach((header, index) => {
            if (!reducedStageIndexes.includes(index)) {
                nonStageHeadersCells.push(index);
            }
        });

        nonStageHeadersCells.splice((!isFacilitator ? 10 : 9), 1);

        const lastStageSubHeaderIndex = !isFacilitator ? 25 : 24;

        sheet.addRow([...rowHeaders.slice(0, lastStageSubHeaderIndex), ...rowHeaders.slice(lastStageSubHeaderIndex + 1)]);

        const leftMarginArray = ['', '', '', '', '', '', '', '', ''];
        if (!isFacilitator) leftMarginArray.push('');

        const stageSubHeaders = stageHeadersCells.reduce(
            (subStageHeaders) => [...subStageHeaders, 'COMPLETED', 'STATUS'],
            leftMarginArray,
        );

        stageSubHeaders[stageSubHeaders.length - 1] = 'OFFER STATUS';

        sheet.addRow([...stageSubHeaders, 'ACTUAL START']);
        // merge horizontal stage headers cells
        stageHeadersCells.forEach(mergeIndexes => {
            sheet.mergeCells(2, mergeIndexes.leftIndex + 1, 2, mergeIndexes.rightIndex + 1)
        });

        // merge vertical non stage headers cells
        nonStageHeadersCells.forEach((cellIndex) => {
            sheet.mergeCells( 2,  cellIndex + 1,  3, cellIndex + 1);
        });

        const headersRows = [sheet.getRow(2), sheet.getRow(3)];

        headersRows.forEach(row => {
            row.eachCell(cell => {
                cell.style = HR_BLACK_HEADERS_STYLES.style;
                cell.fill = HR_BLACK_HEADERS_STYLES.fill;
                cell.font = HR_BLACK_HEADERS_STYLES.font;
            });
        });

        sheet.columns = headers.reduce((columnWidths, h) => (
            [
                ...columnWidths,
                ...(h.isStageHeader ? [{width: h.exportWidth}, {width: h.exportWidth}] : [{width: h.exportWidth}])
            ]
        ), []);

        candidates.forEach(candidate => {

            const row = [];
            headers.forEach(header => {

                const cellValue = header.isStageHeader ?
                    [
                        candidate.candidate_trackings[header.index].date,
                        candidate.candidate_trackings[header.index].status
                    ]:
                    [candidate[header.key]];

                row.push(...cellValue);
            });
            // Avoid to add an extra column (status) for start stage 
            row.splice((isFacilitator ? 24 : 25), 1);
            const addedRow = sheet.addRow(row);

            const totalHeadersCount = isFacilitator ? 27 : 26;
            for (let i = 1; i <= totalHeadersCount; i++) {
                if(i < isFacilitator ? 7 : 6){
                    addedRow.getCell(i).style = {alignment: { wrapText: true }};
                }
                addedRow.getCell(i).font = {
                    color: {argb: '00000000'},
                    family: 2,
                    name: 'Arial',
                    size: 10,
                    bold: false
                };            }
        });

        sheet.views = [
            {
                state: 'frozen',
                xSplit: isFacilitator ? 7 : 6,
                ySplit: 3,
            }
        ];

        await this.downloadBook(workbook, filename);
    }

    async downloadStaffingDasboard(reportData, filename, year) {
        const workbook = this.createBook();
        const sheet = workbook.addWorksheet(filename);

        // Annual sales and marketing headcounts
        addStaffingDashboardTitle(sheet, "Annual Sales & Marketing Headcount Budgeted vs Forecast", false);
        staffingDashboardAnnualSales(sheet, reportData.data.annual_headcounts, reportData.headers.dates, year);

        // Annual sales and marketing headcounts
        addStaffingDashboardTitle(sheet, "Annual Hiring Cadence Plan", true);
        staffingDashboardAnnualHiring(sheet, reportData.data.annual_hiring_data, reportData.headers);

        // Conversion Summary Report
        addStaffingDashboardTitle(sheet, "Conversion Summary Report", true);
        staffingDashboardConversion(sheet, reportData.data.conversion_summary, reportData.headers);

        // New Hire Failure Rate
        addStaffingDashboardTitle(sheet, "New Hire Failure Rate", true);
        staffingDashboardNewHire(sheet, reportData.data.new_hire, reportData.headers);

        // Turn Over Analysis
        addStaffingDashboardTitle(sheet, "Turn Over Analysis", true);
        staffingDashboardTurnOver(sheet, reportData.data.turn_over, reportData.headers);

        const columnWidths = [];
        for (let i = 0; i < 16; i++) {
            if(i == 0){
                columnWidths.push({width: 45});
            }else{
                columnWidths.push({width: 14});
            }
            
        }
        sheet.columns = columnWidths;
        this.downloadBook(workbook, filename);
    }
}

const addStaffingDashboardTitle = (sheet, title, previousRow) => {
    if(previousRow){
        sheet.addRow(['']); // Empty row
    }
    const row = sheet.addRow([title.toUpperCase()]);
    sheet.addRow(['']); // Empty row
    sheet.mergeCells(`${row.getCell(1).address}:${row.getCell(14).address}`);
    row.getCell(1).style = HR_BLACK_HEADERS_STYLES;
};

const staffingDashboardAnnualSales = (sheet, data, dates, year) => {
    // Previous year data
    const annualPrevousYearData = [
        {title: year-1 + ' EOY SALES HEADCOUNT', value: data.lastYearData.sales},
        {title: year-1 + ' EOY MARKETING HEADCOUNT', value: data.lastYearData.marketing},
        {title: year-1 + ' EOY TOTAL SALES & MKTG  HEADCOUNT', value: data.lastYearData.total}
    ]
    annualPrevousYearData.map(element => {
        const row = sheet.addRow([element.title, element.value]);
        if(element.title.includes("TOTAL")){
            row.getCell(1).style = ARIAL_10_BORDER;
            row.getCell(2).style = {
                alignment: { vertical: 'middle', horizontal: 'center'},
                font: { bold:true, ... ARIAL_10 },
                border: {top: {style: 'thin'}}
            };
        }else{
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: { bold:true, ... ARIAL_10 }
            };
            row.getCell(2).style = {
                alignment: { vertical: 'middle', horizontal: 'center'},
                font: { bold:true, ... ARIAL_10 }
            };
        }
    });
    sheet.addRow(['']); // Empty row
    const selectedYear = sheet.addRow(['', year]);
    sheet.mergeCells(`${selectedYear.getCell(2).address}:${selectedYear.getCell(13).address}`);
    selectedYear.getCell(2).style = {
        alignment: { vertical: 'middle', horizontal: 'center'},
        font: { bold:true, ... ARIAL_10 }
    };

    // Selected year data
    const datesRow = sheet.addRow([''].concat(dates));
    for (let index = 2; index <= 13; index++) {
        datesRow.getCell(index).style = {
            alignment: { vertical: 'middle', horizontal: 'center'},
            font: { bold:true, ... ARIAL_10 },
            fill: {
                type: 'pattern',
                pattern:'solid',
                fgColor: {argb: '00b4c7e7'},
                bgColor: {argb: '00b4c7e7'}
            }
        };
    }

    Object.keys(data.currentYearData).map(key => {
        const department = (key == 'sales')? 'Budgeted Sales Staff Headcount' : (key == 'marketing') ? 'Budgeted Marketing Headcount' : 'TOTAL BUDGETED SALES & MKTG HEADCOUNT';
        let rowData = [department];
        dates.map(date => {
            rowData.push(data.currentYearData[key][date]);
        })
        const row = sheet.addRow(rowData);
        if(key == 'total'){
            for (let index = 1; index <= 13; index++) {
                if(index == 1){
                    row.getCell(index).style = ARIAL_10_BORDER;
                }else{
                    row.getCell(index).style = {
                        alignment: { vertical: 'middle', horizontal: 'center'},
                        font: { bold:true, ... ARIAL_10 },
                        border: {top: {style: 'thin'}}
                    };
                }
            }
        }else{
            row.alignment = ARIAL_10_CENTER.alignment;
            row.font = ARIAL_10_CENTER.font;
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: {bold:true, ... ARIAL_10}
            };
        }
    });
};

const staffingDashboardAnnualHiring = (sheet, data, headers) => {
    const datesRow = sheet.addRow([''].concat(headers.dates));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };

    Object.keys(headers.annual_hiring).map(title => {
        let rowData = [headers.annual_hiring[title]];
        headers.dates.map(date => {
            rowData.push(data[title][date]);
        })

        const row = sheet.addRow(rowData);

        if(title.includes('delta')){
            for (let index = 1; index <= 13; index++) {
                if(index == 1){
                    row.getCell(index).style = ARIAL_10_BORDER;
                }else{
                    row.getCell(index).style = {
                        alignment: { vertical: 'middle', horizontal: 'center'},
                        font: { bold:true, ... ARIAL_10 },
                        border: {top: {style: 'thin'}}
                    };
                }
            }
        }else{
            row.alignment = ARIAL_10_CENTER.alignment;
            row.font = ARIAL_10_CENTER.font;
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: ARIAL_10,
            };
        }

        if(title == 'beginning_marketing'){
            const attritionRow = sheet.addRow(['Attrition']);
            attritionRow.getCell(1).style = ARIAL_10_BOLD_LEFT;
            sheet.mergeCells(`${attritionRow.getCell(2).address}:${attritionRow.getCell(13).address}`);
        }else if(title == 'terms_marketing'){
            const hiringRow = sheet.addRow(['Hiring']);
            hiringRow.getCell(1).style = ARIAL_10_BOLD_LEFT;
            sheet.mergeCells(`${hiringRow.getCell(2).address}:${hiringRow.getCell(13).address}`);
        }
    });
};

const staffingDashboardConversion = (sheet, data, headers) => {
    const cumulativeRow = sheet.addRow(['', 'CUMULATIVE']);
    sheet.mergeCells(`${cumulativeRow.getCell(2).address}:${cumulativeRow.getCell(6).address}`);
    for (let index = 2; index <= 6; index++){
        cumulativeRow.getCell(index).style = {
            alignment: { vertical: 'middle', horizontal: 'center'},
            font: { bold:true, ... ARIAL_10 },
            border: {top: {style: 'thin'}}
        };
    }

    sheet.addRow([]); // Empty row

    // Source
    const sourceRow = sheet.addRow(['Source','# Candidates\nPresented','# Candidates\nInterviewed','# Candidates\nHired','Conversion\nRate %','Average Time\nto Fill']);
    sourceRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true};
    sourceRow.font = { bold:true, ... ARIAL_10 };
    sourceRow.getCell(1).style = ARIAL_10_BOLD_LEFT;
    sourceRow.height = 30;

    Object.keys(headers.sources).map(source => {
        let rowData = [headers.sources[source]];
        Object.keys(data.source[source]).map(key => {
            if(key == 'rate'){
                rowData.push(`${data.source[source][key]}%`);
            }else{
                rowData.push(data.source[source][key]);
            }
        })
        const rowSource = sheet.addRow(rowData);

        rowSource.alignment = ARIAL_10_CENTER.alignment;
        rowSource.font = ARIAL_10_CENTER.font;
        rowSource.getCell(1).style = {
            alignment: { vertical: 'middle', horizontal: 'left'},
            font: ARIAL_10,
        };
    });

    sheet.addRow([]); // Empty row

    // Qualified
    let datesRow = sheet.addRow(['Qualified Candidates'].concat(headers.dates));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };
    datesRow.getCell(1).style = ARIAL_10_BOLD_LEFT;

    Object.keys(headers.sources).map(source => {
        let rowData = (source != 'internal')? [`Resumes received - ${headers.sources[source]}`]: ['Total Resumes Received'];
        headers.dates.map(date => {
            if(source != 'internal'){
                rowData.push(data.qualified[source][date]);
            }else{
                rowData.push(data.qualified['total'][date]);
            }
        })
        const row = sheet.addRow(rowData);

        if(source == 'internal'){
            for (let index = 1; index <= 14; index++) {
                if(index == 1){
                    row.getCell(index).style = ARIAL_10_BORDER;
                }else{
                    row.getCell(index).style = {
                        alignment: { vertical: 'middle', horizontal: 'center'},
                        font: { bold:true, ... ARIAL_10 },
                        border: {top: {style: 'thin'}}
                    };
                }
            }
        }else{
            row.alignment = ARIAL_10_CENTER.alignment;
            row.font = ARIAL_10_CENTER.font;
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: ARIAL_10,
            };
        }
    });

    sheet.addRow([]); // Empty row

    // YTD Conversion Summary by Month
    datesRow = sheet.addRow(['YTD Conversion Summary by Month'].concat(headers.dates));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };
    datesRow.getCell(1).style = ARIAL_10_BOLD_LEFT;

    Object.keys(headers.sources).map(source => {
        let rowData = [source.charAt(0).toUpperCase() + source.slice(1)];
        headers.dates.map(date => {
            rowData.push(`${data.ytd[source][date]}%`);
        })
        const row = sheet.addRow(rowData);
        row.alignment = ARIAL_10_CENTER.alignment;
        row.font = ARIAL_10_CENTER.font;
        row.getCell(1).style = {
            alignment: { vertical: 'middle', horizontal: 'left'},
            font: ARIAL_10,
        };
    });

    sheet.addRow([]); // Empty row

    // Average Time to Fill MoM
    datesRow = sheet.addRow(['YTD Conversion Summary by Month'].concat(headers.dates));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };
    datesRow.getCell(1).style = ARIAL_10_BOLD_LEFT;

    Object.keys(headers.sources).map(source => {
        let rowData = [source.charAt(0).toUpperCase() + source.slice(1)];
        headers.dates.map(date => {
            rowData.push(data.avgttf[source][date]);
        })
        const row = sheet.addRow(rowData);
        row.alignment = ARIAL_10_CENTER.alignment;
        row.font = ARIAL_10_CENTER.font;
        row.getCell(1).style = {
            alignment: { vertical: 'middle', horizontal: 'left'},
            font: ARIAL_10,
        };
    });

    sheet.addRow([]); // Empty row

    // Average Time to Start (Resume to Start)
    datesRow = sheet.addRow(['YTD Conversion Summary by Month'].concat(headers.dates));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };
    datesRow.getCell(1).style = ARIAL_10_BOLD_LEFT;

    Object.keys(headers.sources).map(source => {
        let rowData = [source.charAt(0).toUpperCase() + source.slice(1)];
        headers.dates.map(date => {
            rowData.push(data.avgtts[source][date]);
        })
        const row = sheet.addRow(rowData);
        row.alignment = ARIAL_10_CENTER.alignment;
        row.font = ARIAL_10_CENTER.font;
        row.getCell(1).style = {
            alignment: { vertical: 'middle', horizontal: 'left'},
            font: ARIAL_10,
        };
    });
};

const staffingDashboardNewHire = (sheet, data, headers) => {
    const datesRow = sheet.addRow(['Termination Gate'].concat(headers.dates.concat(['TOTAL'])));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };

    datesRow.getCell(1).style = ARIAL_10_BOLD_LEFT;

    Object.keys(data).map(days => {
        let rowData = (days != '365' && days != 'total')? [`${days} Days`]: (days == '365') ? ['&gt 181 days &lt 1 year'] : ['Total'];
        headers.dates.map(date => {
            rowData.push(data[days][date]);
        })
        rowData.push(data[days]["total"]);
        const row = sheet.addRow(rowData);

        if(days == 'total'){
            for (let index = 1; index <= 14; index++) {
                if(index == 1){
                    row.getCell(index).style = ARIAL_10_BORDER;
                }else{
                    row.getCell(index).style = {
                        alignment: { vertical: 'middle', horizontal: 'center'},
                        font: { bold:true, ... ARIAL_10 },
                        border: {top: {style: 'thin'}}
                    };
                }
            }
        }else{
            row.alignment = ARIAL_10_CENTER.alignment;
            row.font = ARIAL_10_CENTER.font;
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: ARIAL_10,
            };
        }
    });
};

const staffingDashboardTurnOver = (sheet, data, headers) => {
    // Type
    const datesRow = sheet.addRow(['Type'].concat(headers.dates.concat(['TOTAL'])));
    datesRow.alignment = { vertical: 'middle', horizontal: 'center'};
    datesRow.font = { bold:true, ... ARIAL_10 };
    datesRow.getCell(1).style = ARIAL_10_BOLD_LEFT;

    Object.keys(data.type).map(type => {
        let rowData = [type.charAt(0).toUpperCase() + type.slice(1)];
        headers.dates.map(date => {
            rowData.push(data.type[type][date]);
        })
        rowData.push(data.type[type]["total"]);
        const row = sheet.addRow(rowData);

        if(type == 'total'){
            for (let index = 1; index <= 14; index++) {
                if(index == 1){
                    row.getCell(index).style = ARIAL_10_BORDER;
                }else{
                    row.getCell(index).style = {
                        alignment: { vertical: 'middle', horizontal: 'center'},
                        font: { bold:true, ... ARIAL_10 },
                        border: {top: {style: 'thin'}}
                    };
                }
            }
        }else{
            row.alignment = ARIAL_10_CENTER.alignment;
            row.font = ARIAL_10_CENTER.font;
            row.getCell(1).style = {
                alignment: { vertical: 'middle', horizontal: 'left'},
                font: ARIAL_10,
            };
        }
    });
    sheet.addRow([]); // Empty row

    const reasonRow = sheet.addRow(['Reason']);
    reasonRow.style = {
        alignment: { vertical: 'middle', horizontal: 'left'},
        font: ARIAL_10,
    };
    reasonRow.getCell(1).style = ARIAL_10_BOLD_LEFT;
    // Reasons
    Object.keys(headers.reasons).map(reason => {
        let rowData = [headers.reasons[reason]];
        headers.dates.map(date => {
            rowData.push(data.reasons[reason][date]);
        })
        rowData.push(data.reasons[reason]['total']);
        const row = sheet.addRow(rowData);

        row.alignment = ARIAL_10_CENTER.alignment;
        row.font = ARIAL_10_CENTER.font;
        row.getCell(1).style = {
            alignment: { vertical: 'middle', horizontal: 'left'},
            font: ARIAL_10,
        };
    });
    let rowData = ['Total Terminations'];
    headers.dates.map(date => {
        rowData.push(data.reasons['total'][date]);
    })
    rowData.push(data.reasons['total']['total']);
    const row = sheet.addRow(rowData);

    row.style = ARIAL_10_CENTER;
    row.getCell(1).style = {
        alignment: { vertical: 'middle', horizontal: 'left'},
        font: ARIAL_10,
    };
    for (let index = 1; index <= 14; index++) {
        if(index == 1){
            row.getCell(index).style = ARIAL_10_BORDER;
        }else{
            row.getCell(index).style = {
                alignment: { vertical: 'middle', horizontal: 'center'},
                font: { bold:true, ... ARIAL_10 },
                border: {top: {style: 'thin'}}
            };
        }
    }
};

let ExportService = new ExportServiceClass(ENVIRONMENT.API_HOST);
export default ExportService;
